var render = function (_h,_vm) {var _c=_vm._c;return _vm._m(0)}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"ine-form__background"},[_c('img',{staticClass:"ine-form__logo",attrs:{"src":require("@/assets/images/home-logo.png"),"alt":"INE logo"}})])}]

export { render, staticRenderFns }